import { useState, useEffect, useRef } from 'react';

import {
  Box,
  Text,
  Flex,
  Stack,
  List,
  ListItem,
  Editable,
  EditablePreview,
  EditableTextarea,
  EditableInput,
  ButtonGroup,
  IconButton,
  useBreakpointValue,
  useEditableControls,
  useDisclosure,Menu, MenuButton, MenuList, MenuItem, AlertDialog,AlertDialogBody,AlertDialogFooter,AlertDialogHeader,AlertDialogContent,AlertDialogOverlay,Button,Modal,ModalBody,ModalCloseButton,ModalContent,ModalFooter,ModalOverlay,Badge,ModalHeader,Grid,GridItem,
} from '@chakra-ui/react';
import { EditIcon, CheckIcon, CloseIcon, ViewIcon, ArrowBackIcon, ChevronDownIcon, ChatIcon, Tooltip } from '@chakra-ui/icons'; // Import ChevronDownIcon
import { BsThreeDotsVertical } from 'react-icons/bs'; // Import three-dots icon
import profileImg from '../../assets/profileimg.jpg'; // Adjust the path as necessary
import { useSelector, useDispatch } from 'react-redux';
import { fetchJobDetails,fetchInvoicePaymentDetails } from '../../store/slices/jobDetailsSlice'; // Adjust the import path
import axios from 'axios';
import ApplicantProfile from './applicantProfile';
import ClockInTimer from './ClockInTimer';

function EditableWithControls({ value, onChange, name, type = "text", isTextarea = false, maxLength, showControls = true ,fontSize}) {
  function EditableControls() {
    const { isEditing, getSubmitButtonProps, getCancelButtonProps, getEditButtonProps } =
      useEditableControls();

    return isEditing ? (
      <ButtonGroup justifyContent="end" size="sm" mt={2}>
        <IconButton
          icon={<CheckIcon />}
          {...getSubmitButtonProps()}
          color="blue.600"
          bg="transparent"
          _hover={{ bg: 'transparent' }}
        />
        <IconButton
          icon={<CloseIcon />}
          {...getCancelButtonProps()}
          color="blue.600"
          bg="transparent"
          fontSize="11px"
          _hover={{ bg: 'transparent' }}
        />
      </ButtonGroup>
    ) : (
      showControls && (
        <IconButton
          size="sm"
          icon={<EditIcon />}
          {...getEditButtonProps()}
          color="blue.600"
          bg="transparent"
          _hover={{ bg: 'transparent' }}
        />
      )
    );
  }

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    if (name === 'jobTitle') {
      if (/^[a-zA-Z\s]*$/.test(newValue)) {
        onChange(newValue);
      }
    } else {
      onChange(newValue);
    }
  };

  return (
    <Editable
      value={value}
      name={name}
      isPreviewFocusable={false}
      submitOnBlur={false}
    >
      <Flex justifyContent="space-between" alignItems="center">
        <EditablePreview fontWeight="normal" fontSize={fontSize} color="black" textAlign="left"/> {/* Aligning preview text to the left */}
        {isTextarea ? (
          <EditableTextarea
            type={type}
            _focus={{ boxShadow: 'none', borderColor: 'gray.300', borderWidth: '1px' }}
            width="100%"
            height="130px"
            maxLength={maxLength}
            onChange={handleInputChange}
            textAlign="left" // Aligning textarea text to the left
          />
        ) : (
          <EditableInput
            type={type}
            _focus={{ boxShadow: 'none', borderColor: 'gray.300', borderWidth: '1px' }}
            maxLength={maxLength}
            onChange={handleInputChange}
          />
        )}
        {showControls && <EditableControls />}
      </Flex>
    </Editable>
  );
}
function PeopleTabs({ selectedTab, onTabChange }) {
  return (
    <Flex justify="flex-start" mb={4}>
       <Box
        as="button"
        px={4}
        py={2}
        fontWeight="bold"
        borderBottom={selectedTab === 'Hired' ? '1px solid blue' : 'none'}
        color={selectedTab === 'Hired' ? 'black' : 'gray.600'}
        onClick={() => onTabChange('Hired')}
      >
        Hired
      </Box>
      <Box
        as="button"
        px={4}
        py={2}
        fontWeight="bold"
        borderBottom={selectedTab === 'Applied' ? '1px solid blue' : 'none'}
        color={selectedTab === 'Applied' ? 'black' : 'gray.600'}
        onClick={() => onTabChange('Applied')}
        mr={4}
      >
        Applied
      </Box>
     
    </Flex>
  );
}
function JobDetailsCard({ jobId, onBack, onViewApplicant, fromHistory ,onChatClick}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef();
  const dispatch = useDispatch();
  const jobDetailsState = useSelector((state) => state.jobDetails); // Access jobDetails state
  const { jobDetails: fetchedJobDetails, loading, error } = jobDetailsState; // Rename destructured variable
  const [selectedTab, setSelectedTab] = useState('Applied');
  const [selectedApplicantPayments, setSelectedApplicantPayments] = useState(null);
  const { invoicePaymentDetails } = useSelector((state) => state.jobDetails);
  const chatButtonPosition = useBreakpointValue({
    base: { top: '10px', right: '20px' }, // Small screens
    md: { top: '50px', left: '300px' },   // Medium screens
    lg: { top: '50px', left: '500px' },   // Large screens
    xl: { top: '50px', left: '700px' },   // Extra-large screens
  });

  // const [jobDetails, setJobDetails] = useState({
  //   jobTitle: 'Senior Radiologist',
  //   description:
  //     'We are seeking a skilled and compassionate Radiologist to join our healthcare team. The ideal candidate will have a strong background in administering radiation treatments to patients, working as part of a multidisciplinary team to treat cancer and other diseases. As a Radiologist, you will be responsible for the precise delivery of radiation doses to ensure the best possible outcomes for our patients.',
  //   appliedPeople: ['John Doe', 'Jane Smith', 'Michael Brown', 'John Doe', 'Jane Smith', 'Michael Brown'],
  //   startDate: '2024-10-10',
  //   endDate: '2024-11-01',
  //   startTime: '09:00',
  //   endTime: '17:00',
  //   salary: 50000,
  //   skills: 'Radiology, Oncology, Radiation Therapy',
  //   vacancies: 2,
  //   location: 'California, USA',
  // });
  const [jobDetails, setJobDetails] = useState({
    jobTitle: '',
    description: '',
    appliedCandidates: [], 
    hiredCandidates: [],
    startDate: '',
    endDate: '',
    startTime: '',
    endTime: '',
    salary: 0,
    salaryUnit: '',
    currencyType: '',
    mandatorySkills: [],
    otherSkills: [],
    vacancies: 0,
    settlementPeriod: 0,
    country: '',
    address: '',
    pinCode: '',
    region: '',
  });
const [selectedApplicant, setSelectedApplicant] = useState({});
  const [clockStatuses, setClockStatuses] = useState({});
  
  useEffect(() => {
    if (jobId) {
      //console.log(jobId);
      dispatch(fetchJobDetails(jobId)); // Dispatch the thunk action
    }
  }, [jobId, dispatch]);
  useEffect(() => {
    // When fetched job details change, update local state
    if (fetchedJobDetails) {
      setJobDetails(fetchedJobDetails);
    }
  }, [fetchedJobDetails]);

  const fetchClockStatuses = async (candidates) => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const statuses = {};

    for (const candidate of candidates) {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/api/get-clock-status/${jobId}/${candidate.userId}`,
          {
            headers: {
              Authorization: `Bearer ${ticketToken}`,
            },
          }
        );
        if (response.data.success) {
          statuses[candidate.userId] = response.data.data;
        }
      } catch (error) {
        console.error(`Error fetching clock status for ${candidate.userId}:`, error);
        // Handle different error cases
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          if (error.response.status === 404) {
            // No clock record found - this is normal for users who haven't clocked in
            // console.log(`No clock record found for user ${candidate.userId}`);
            console.log("No clock record found for user");
          } else {
            console.error('Server error response:', error.response.data);
          }
        } else if (error.request) {
          // The request was made but no response was received
          console.error('No response received from server');
        } else {
          // Something happened in setting up the request that triggered an Error
          console.error('Error setting up request:', error.message);
        }
      }
    }
    setClockStatuses(statuses);
  };

  useEffect(() => {
    if (jobDetails.hiredCandidates?.length > 0) {
      fetchClockStatuses(jobDetails.hiredCandidates);
    }
  }, [jobDetails.hiredCandidates]);

  // Handle loading and error states
  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  const handleInputChange = (name, value) => {
    setJobDetails({ ...jobDetails, [name]: value });
  };

  const handleDeleteJob = async (jobId) => {
    // console.log(jobId);
    try {
      const ticketToken = sessionStorage.getItem('ticketToken');
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/delete-job`, 
        { jobId: jobId }, // Send jobId in the request body
        {
          headers: {
            Authorization: `Bearer ${ticketToken}`,
          },
        }
      );
      onClose(); // Close the alert dialog after deletion
    } catch (error) {
      console.error('Error deleting job:', error);
    }
  };


  const handleMenuItemClick = (jobId) => {
    onOpen(); // Open the alert dialog
     // Call the function to delete the job
  };

  const handleDeleteClick = (jobId) => {
    handleDeleteJob(jobId);
    onBack() // Call the function to delete the job
  };
  const handleViewApplicant = (userId,isHired) => {
    // console.log("Applicant selected - userId:", userId, "isHired:", isHired); // Log userId and isHired status
    setSelectedApplicant({ userId, isHired });
    onViewApplicant(userId,isHired); // Set the selected job in ProviderHome
    // console.log("Applicant is selected userId:", userId); // Log the userId

  };
  const handleTabChange = (tab) => setSelectedTab(tab);
  const handleViewInvoicePaymentDetails = () => {
    dispatch(fetchInvoicePaymentDetails(jobId));
    console.log("invoicePaymentDetails",invoicePaymentDetails);
  };
// Add this function to filter payment details
const getApplicantPaymentDetails = (invoiceNo) => {
  return invoicePaymentDetails.filter(detail => 
    detail.invoiceNo === invoiceNo
  );
};

  return (
    <Flex p={5} wrap="wrap" width="100%" position="relative">
      <IconButton
        icon={<ArrowBackIcon />}
        position="absolute"
        size="sm"
        top="0px" // Move to the top
        left="0px" // Move to the left
        color="blue.500" // Change icon color to black
        bg="transparent" // Remove background color
        _hover={{ bg: 'transparent' }} // Ensure no background on hover
        onClick={onBack}
      />
      
      <Box flex={{ base: '1 1 100%', md: '0 0 60%' }} p={4} borderWidth="1px" borderRadius="md" m={2} boxShadow="md">
      <Stack spacing={4}>
      {/* Job Title and Chat Icon Row */}
      <Flex
        justify="space-between"
        align="center"
        mb={10}
      >
        <EditableWithControls
          value={jobDetails.jobTitle || ''}
          onChange={(val) => handleInputChange('jobTitle', val)}
          name="jobTitle"
          type="text"
          maxLength={50}
          showControls={false}
          fontSize="24px"
        />
        {selectedTab === 'Hired' && (
          <IconButton
            icon={<ChatIcon />}
            size="md"
            colorScheme="blue"
            onClick={() => onChatClick(jobId)}
            aria-label="Chat with applicants"
            ml={4} // Margin to separate from the title
          />
        )}
      </Flex>
          <Box mb={5}>
            <Text fontSize="lg" color="gray.500" textAlign="left">Description</Text>
            <EditableWithControls
              value={jobDetails.description || ''}
              onChange={(val) => handleInputChange('description', val)}
              name="description"
              isTextarea={true}
              width="100%"
              height="160px"
              maxLength={500}
              showControls={false}
              fontSize="16px"
              textAlign="left" // Aligning description text to the left
            />
          </Box>
{/* 
          <Box mb={5} p={3} maxHeight="270px" overflowY="auto">
            <Text fontSize="lg" color="gray.500" textAlign="left" mb={'4'}>Applied People</Text>
            <List spacing={2}>
              {jobDetails.appliedCandidates && jobDetails.appliedCandidates.map((applicant) => ( // Add a check for appliedPeople
                <ListItem 
                  key={applicant.userId} 
                  borderWidth="1px" 
                  borderColor="gray.300" 
                  borderRadius="md" 
                  fontSize="16px"
                  p={2} 
                  _hover={{ bg: 'gray.100' }} // Hover effect
                >
                  <Flex justify="space-between" alignItems="center">
                    <Flex alignItems="center">
                      <Box
                        as="img"
                        src={applicant.profile_image_url||profileImg} // Use the imported profile image
                        alt={`${applicant.FullName}'s profile`}
                        borderRadius="full"
                        boxSize="30px"
                        mr={2}
                      />
                      <Text>{applicant.FullName||"No Name"}</Text>
                    </Flex>
                    <IconButton
                      icon={<ViewIcon />}
                      onClick={() => {
                        handleViewApplicant(applicant.userId,applicant.isHired)
                        console.log("applicant userId:",applicant.userId);
                      }}
                      size="xs"
                      colorScheme="blue"
                      color="white"
                      bg="blue.400"
                      _hover={{ bg: 'blue.500' }}
                    />
                  </Flex>
                </ListItem>
              ))}
            </List>
          </Box>
        </Stack>
      </Box> */}
     {fromHistory ? (
  <>
    {/* Hired People Heading */}
    <Text fontSize="lg" fontWeight="bold" mb={4}>
      Hired People
    </Text>
    {/* Hired People List */}
    <Box mb={5} p={3} maxHeight="270px" overflowY="auto">
      <List spacing={2}>
        {jobDetails.hiredCandidates?.length > 0 ? (
          jobDetails.hiredCandidates.map((applicant) => (
            <ListItem
              key={applicant.userId}
              borderWidth="1px"
              borderColor="gray.300"
              borderRadius="md"
              fontSize="16px"
              p={2}
              _hover={{ bg: 'gray.100' }}
            >
              <Flex justify="space-between" alignItems="center" width="100%">
                <Flex alignItems="center">
                  <Box
                    as="img"
                    src={applicant.profile_image_url || profileImg}
                    alt={`${applicant.FullName}'s profile`}
                    borderRadius="full"
                    boxSize="30px"
                    mr={2}
                  />
                  <Text>{applicant.FullName || "No Name"}</Text>
                </Flex>
                <Flex alignItems="center" gap={2}>
                  {clockStatuses[applicant.userId]?.clockInTime && (
                    <ClockInTimer 
                      clockInTime={clockStatuses[applicant.userId].clockInTime}
                      clockOutTime={clockStatuses[applicant.userId].clockOutTime}
                    />
                  )}
                  {/* <IconButton
                    icon={<ViewIcon />}
                    onClick={() => handleViewApplicant(applicant.userId, applicant.isHired)}
                    size="xs"
                    colorScheme="blue"
                    color="white"
                    bg="blue.400"
                    _hover={{ bg: 'blue.500' }}
                  /> */}
                </Flex>
                <Flex alignItems="center" gap={2}>
                  <IconButton
                    icon={<ViewIcon />}
                    onClick={() => handleViewApplicant(applicant.userId, applicant.isHired)}
                    size="xs"
                    colorScheme="blue"
                    color="white"
                    bg="blue.400"
                    _hover={{ bg: 'blue.500' }}
                  />
                  <Menu>
                    <MenuButton
                      as={IconButton}
                      icon={<BsThreeDotsVertical />}
                      variant="ghost"
                      size="xs"
                      color="gray.600"
                      _hover={{ bg: 'gray.100' }}
                    />
                    <MenuList>
                      <MenuItem
                        onClick={() => {
                          // console.log("Fetching payment details for jobId:", jobId);
                          dispatch(fetchInvoicePaymentDetails(jobId));
                          console.log("invoicePaymentDetails",invoicePaymentDetails);
                          setSelectedApplicantPayments(applicant);
                          console.log("Selected applicant:", applicant);
                        }}
                      >
                        View Payment Details
                      </MenuItem>
                    </MenuList>
                  </Menu>
                </Flex>
              </Flex>
            </ListItem>
          ))
        ) : (
          <Text fontSize="16px" color="gray.500" textAlign="center" mt={4}>
            No applicants have been hired yet.
          </Text>
        )}
      </List>
    </Box>
  </>
) : (
  <>
      {/* Tab Component */}
      <PeopleTabs selectedTab={selectedTab} onTabChange={handleTabChange} />

<Box mb={5} p={3} maxHeight="270px" overflowY="auto">
  <List spacing={2}>
  {(selectedTab === 'Applied' ? (jobDetails.appliedCandidates || []) : (jobDetails.hiredCandidates || [])).length > 0 ? (
    (selectedTab === 'Applied' ? jobDetails.appliedCandidates : jobDetails.hiredCandidates)?.map((applicant) => (
      <ListItem
        key={applicant.userId}
        borderWidth="1px"
        borderColor="gray.300"
        borderRadius="md"
        fontSize="16px"
        p={2}
        _hover={{ bg: 'gray.100' }}
      >
        <Flex justify="space-between" alignItems="center" width="100%">
          <Flex alignItems="center">
            <Box
              as="img"
              src={applicant.profile_image_url || profileImg}
              alt={`${applicant.FullName}'s profile`}
              borderRadius="full"
              boxSize="30px"
              mr={2}
            />
            <Text>{applicant.FullName || "No Name"}</Text>
          </Flex>
          <Flex alignItems="center" gap={2}>
            {clockStatuses[applicant.userId]?.clockInTime && (
              <ClockInTimer 
                clockInTime={clockStatuses[applicant.userId].clockInTime}
                clockOutTime={clockStatuses[applicant.userId].clockOutTime}
              />
            )}
            <IconButton
              icon={<ViewIcon />}
              onClick={() => handleViewApplicant(applicant.userId, applicant.isHired)}
              size="xs"
              colorScheme="blue"
              color="white"
              bg="blue.400"
              _hover={{ bg: 'blue.500' }}
            />
          </Flex>
        </Flex>
      </ListItem>
    ))
  ) : (
    <Text fontSize="16px" color="gray.500" textAlign="center" mt={4}>
 {selectedTab === 'Applied'
          ? (jobDetails.hiredCandidates|| []).length > 0
            ? "All applicants have been hired."
            : "No applicants have applied yet."
          : "No applicants have been hired yet."}    </Text>
  )}
  </List>
</Box>
</>
)}
</Stack>
</Box>

      <Box flex={{ base: '1 1 100%', md: '0 0 35%' }} p={4} borderWidth="1px" borderRadius="md" m={2} boxShadow="md"  overflowY="auto" maxHeight={{ base: 'auto', md: '80vh' }} >
        <Stack spacing={4}>
        <Flex
  justify="space-between"
  alignItems="center"
  bg="gray.200" // Set the background color for the entire container
  p={2}
  borderRadius="md"
  width="100%" // Ensure it spans the full width of the box
>
  <Text
    fontSize="16px"
    color="black"
    textAlign="left"
  >
    Job Details
  </Text>

  {/* Conditionally render the menu */}
  {!fromHistory && (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={<BsThreeDotsVertical />}
        variant="ghost"
        aria-label="Options"
        size="sm"
        bg="transparent"
        _hover={{ bg: 'transparent' }} // Ensure no background on hover
      />
      <MenuList>
      <Tooltip label="Cannot delete a job with hired candidates" isDisabled={!(jobDetails.hiredCandidates?.length > 0)}>
        <MenuItem onClick={() => handleMenuItemClick(jobId)}  color="black" _hover={{bg:"red.500",color:"white"}} isDisabled={jobDetails.hiredCandidates?.length > 0}>Delete Job </MenuItem>
        </Tooltip>
        {/* Replace console.log with delete logic */}
      </MenuList>
    </Menu>
  )}
</Flex>

          <Box> {/* Always visible job details */}
            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Start Date</Text>
              <Text fontSize="16px" color="black" textAlign="left">{jobDetails.startDate || ''}</Text> {/* Non-editable */}
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">End Date</Text>
              <Text fontSize="16px" color="black" textAlign="left">{jobDetails.endDate || ''}</Text> {/* Non-editable */}
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Start Time</Text>
              <EditableWithControls
                value={jobDetails.startTime || ''}
                onChange={(val) => handleInputChange('startTime', val)}
                name="startTime"
                type="time"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">End Time</Text>
              <EditableWithControls
                value={jobDetails.endTime || ''}
                onChange={(val) => handleInputChange('endTime', val)}
                name="endTime"
                type="time"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Salary</Text>
              <EditableWithControls
                value={`${jobDetails.salary?.toString() || '0'}  ${jobDetails.currencyType || ''}${jobDetails.salaryUnit || ''}`} // Ensure salary is a string
                onChange={(val) => handleInputChange('salary', parseInt(val, 10))}
                name="salary"
                type="number"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            <Box mb={4}>
  <Text fontSize="sm" color="gray.500" textAlign="left">Country</Text>
  <EditableWithControls
    value={jobDetails.country?.name || ''} // Access the 'name' property or use an empty string if undefined
    onChange={(val) => handleInputChange('country', { ...jobDetails.country, name: val })} // Update only the 'name' property
    name="country"
    type="text"
    showControls={false}
    fontSize="16px"
  />
</Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Address</Text>
              <EditableWithControls
                value={jobDetails.address || ''}
                onChange={(val) => handleInputChange('address', val)}
                name="address"
                type="text"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Postal Code</Text>
              <EditableWithControls
                value={jobDetails.pinCode || ''}
                onChange={(val) => handleInputChange('pinCode', val)}
                name="pinCode"
                type="text"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Region</Text>
              <EditableWithControls
                value={jobDetails.region || ''}
                onChange={(val) => handleInputChange('region', val)}
                name="region"
                type="text"
                showControls={false}
                fontSize="16px"
              />
            </Box>

            {/* <Box mb={4}>
           <Text fontSize="sm" color="gray.500" textAlign="left">Skills needed</Text>
         <Stack spacing={1}>
               {(Array.isArray(jobDetails.skills) ? jobDetails.skills : (jobDetails.skills || '').split(/[\s,]+/))
                .filter(skill => skill.trim() !== "")
      .map((skill, index) => (
        <Text key={index} fontSize="16px" color="black" textAlign="left">
          {skill}
        </Text>
      ))}
  </Stack>
</Box> */}
<Box mb={4}>
  <Text fontSize="sm" color="gray.500" textAlign="left">Mandatory Skills</Text>
  <Stack spacing={1}>
    {(Array.isArray(jobDetails.mandatorySkills) 
      ? jobDetails.mandatorySkills 
      : (jobDetails.mandatorySkills || '').split(/[\s,]+/))
      .filter(skill => skill.trim() !== "")
      .map((skill, index) => (
        <Text key={index} fontSize="16px" color="black" textAlign="left">
          {skill}
        </Text>
      ))
    }
  </Stack>
</Box>

<Box mb={4}>
  <Text fontSize="sm" color="gray.500" textAlign="left">Other Skills</Text>
  <Stack spacing={1}>
    {(Array.isArray(jobDetails.otherSkills) 
      ? jobDetails.otherSkills 
      : (jobDetails.otherSkills || '').split(/[\s,]+/))
      .filter(skill => skill.trim() !== "")
      .map((skill, index) => (
        <Text key={index} fontSize="16px" color="black" textAlign="left">
          {skill}
        </Text>
      ))
    }
  </Stack>
</Box>

<Box mb={4}>
  <Text fontSize="sm" color="gray.500" textAlign="left">Settlement Period</Text>
  <EditableWithControls
    value={`within ${jobDetails.settlementPeriod?.toString() || '0'} `} // Ensure settlementPeriod is a string
    onChange={(val) => handleInputChange('settlementPeriod', parseInt(val, 10))}
    name="settlementPeriod"
    type="number"
    showControls={false}
    fontSize="16px"
  />
</Box>


    {/* AlertDialog for confirming job deletion */}
    <AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
  <AlertDialogOverlay>
    <AlertDialogContent>
      <AlertDialogHeader fontSize="lg" fontWeight="bold">
        Delete Job
      </AlertDialogHeader>

      <AlertDialogBody>
        Are you sure? You can't undo this action afterwards.
      </AlertDialogBody>

      <AlertDialogFooter>
        <Button ref={cancelRef} onClick={onClose}>
          Cancel
        </Button>
        <Button 
          colorScheme="red" 
          onClick={() => handleDeleteClick(jobId)} // Call handleDeleteJob here
          ml={3}
        >
          Delete
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialogOverlay>
</AlertDialog>

            <Box mb={4}>
              <Text fontSize="sm" color="gray.500" textAlign="left">Vacancies</Text>
              <EditableWithControls
                value={jobDetails.vacancies?.toString() || '0'} // Ensure vacancies is a string
                onChange={(val) => handleInputChange('vacancies', parseInt(val, 10))}
                name="vacancies"
                type="number"
                showControls={false}
                fontSize="16px"
              />
            </Box>
          </Box>
        </Stack>
          {/* Popup Modal */}
      {/* <Modal isOpen={isOpen} onClose={onClose} size="xl" width="50%">
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody>
            <ApplicantProfile />
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal> */}
      </Box>

      {/* Payment Details Overlay */}
      {selectedApplicantPayments && (
        <Box
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          bg="blackAlpha.600"
          zIndex="overlay"
          onClick={() => setSelectedApplicantPayments(null)}
        >
          <Box
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
            bg="white"
            p={6}
            borderRadius="md"
            maxWidth="800px"
            width="90%"
            maxHeight="80vh"
            overflowY="auto"
            onClick={(e) => e.stopPropagation()}
          >
            <Flex justify="space-between" mb={4}>
              <Text fontSize="xl" fontWeight="bold">
                Payment Details - {selectedApplicantPayments.FullName}
              </Text>
              <IconButton
                icon={<CloseIcon />}
                size="sm"
                onClick={() => setSelectedApplicantPayments(null)}
                variant="ghost"
              />
            </Flex>
            {invoicePaymentDetails && invoicePaymentDetails
              .filter(detail => detail.employeeName === selectedApplicantPayments.FullName)
              .map((detail, index) => (
                <Box 
                  key={index}
                  p={4}
                  borderWidth="1px"
                  borderRadius="md"
                  mb={4}
                  bg="gray.50"
                >
                  <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Invoice Number</Text>
                      <Text>{detail.invoiceNumber}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Amount</Text>
                      <Text>{detail.amount}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Status</Text>
                      <Badge 
                        colorScheme={
                          detail.status === 'COMPLETED' ? 'green' : 
                          detail.status === 'PENDING' ? 'yellow' : 
                          'red'
                        }
                      >
                        {detail.status}
                      </Badge>
                    </Box>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Invoice Status</Text>
                      <Badge 
                        colorScheme={
                          detail.invoiceStatus === 'paid' ? 'green' : 
                          detail.invoiceStatus === 'pending' ? 'yellow' : 
                          'red'
                        }
                      >
                        {detail.invoiceStatus}
                      </Badge>
                    </Box>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Submission Date</Text>
                      <Text>{detail.paymentDate ? new Date(detail.paymentDate).toLocaleDateString() : 'N/A'}</Text>
                    </Box>
                    <Box>
                      <Text fontWeight="bold" color="gray.600">Payment Method</Text>
                      <Text>{detail.paymentMethod || 'N/A'}</Text>
                    </Box>
                    {detail.failureReason && (
                      <Box gridColumn="span 2">
                        <Text fontWeight="bold" color="gray.600">Failure Reason</Text>
                        <Text color="red.500">{detail.failureReason}</Text>
                      </Box>
                    )}
                    <Box gridColumn="span 2">
                      <Text fontWeight="bold" color="gray.600" mb={2}>Bank Details</Text>
                      <Stack pl={4}>
                        <Text>Account Name: {detail.bankDetails.accountName}</Text>
                        <Text>Bank Name: {detail.bankDetails.bankName}</Text>
                      </Stack>
                    </Box>
                  </Grid>
                </Box>
              ))}
            {invoicePaymentDetails.filter(detail => 
              detail.employeeName === selectedApplicantPayments.FullName
            ).length === 0 && (
              <Text textAlign="center" color="gray.500">
                No payment details found for this applicant
              </Text>
            )}
          </Box>
        </Box>
      )}
    </Flex>
  );
}

export default JobDetailsCard;